<template>
  <div class="deposit">
      <div class="deposit_1">
        <div :class="index_active==1?'active':'' ">
          <router-link to="/affiche/affiche_list">{{this.$t('beth_text.msg_notice')}}</router-link>
        </div>
        <div :class="index_active==2?'active':'' ">
          <router-link to="/affiche/affiche_list_admin">{{this.$t('beth_text.system_notice')}}</router-link>
        </div>

      </div>
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index_active:1,
    }
  },
  methods: {
    set_active(){
      if(this.$route.path=='/affiche/affiche_list'){
        this.index_active = 1;
      }else if(this.$route.path=='/affiche/affiche_list_admin'){
        this.index_active = 2;
      }
    },
  },
  mounted() {
    this.set_active();
  },
  watch:{
    $route(){
      this.set_active();
    }
  }
}
</script>

<style scoped>


.deposit_1{
  border-bottom: 1px solid #314B69;
  display: flex;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
}
.deposit_1 a{
  color: #fff;
}
.deposit_1>div{
  margin-right: 40px;
}
.active{
  font-style: normal;
  font-weight: 700;
  color: 00C18E;
  border-bottom: 3px solid #00C18E;
  padding-bottom: 4px;
}
.active a{
  color: #00C18E;
}
</style>

<style scoped>
  /* 手机端 */
@media screen and (max-width: 850px) {
  .deposit_1{
    font-size: 12px;
  }
  
}
</style>